import { type FOfferType, isSuburban } from '@/packages/JsonQuery';
import { EMetroTravelType } from '@/packages/api-models/common/json_query';

export const getTravelTypeByOfferType = (offerType: FOfferType): EMetroTravelType =>
  isSuburban(offerType) ? EMetroTravelType.MapTransport : EMetroTravelType.MapFoot;
